import { Placement } from "@floating-ui/react";
import * as React from "react";
import { SudoTooltip } from "src/sudokit/components/SudoTooltip";
export interface TooltipContent {
  isShown: boolean;
  content: React.ReactNode | string;
  onClose?: (isOpen?: boolean) => void;
  closable?: boolean;
  tooltipClasses?: string;
  isOpen?: boolean;
  animate?: boolean;
  controlledOpen?: boolean;
  showArrow?: boolean;
  disabled?: boolean;
  placement?: Placement | undefined;
  arrowOffset?: number;
  closeButtonClassName?: string;
  arrowColor?: string;
}

const defaultTooltip: TooltipContent = {
  isShown: false,
  content: null,
  onClose: (isOpen?: boolean) => {},
  closable: false,
  tooltipClasses: "",
  isOpen: false,
  animate: false,
  controlledOpen: false,
  showArrow: true,
  disabled: false,
  placement: "bottom" as Placement,
  arrowOffset: 0,
};

interface MultiUseTooltipProps {
  children: React.ReactNode;
  tooltips: TooltipContent[];
}

export const MultiUseTooltip: React.FC<MultiUseTooltipProps> = ({ children, tooltips = [defaultTooltip] }) => {
  const selectedTooltip = tooltips.find((tooltip) => tooltip.isShown) ?? defaultTooltip;

  if (!selectedTooltip.isShown) {
    return <>{children}</>;
  }

  return (
    <SudoTooltip
      text={typeof selectedTooltip.content === "string" ? selectedTooltip.content : ""}
      customContent={selectedTooltip.content}
      onOpenChange={selectedTooltip.onClose}
      closable={selectedTooltip.closable}
      tooltipClassName={selectedTooltip.tooltipClasses}
      open={selectedTooltip.isOpen}
      animate={selectedTooltip.animate}
      controlledOpen={selectedTooltip.controlledOpen}
      hasArrow={selectedTooltip.showArrow}
      disabled={selectedTooltip.disabled}
      position={selectedTooltip.placement}
      arrowOffset={selectedTooltip.arrowOffset}
      closeButtonClassName={selectedTooltip.closeButtonClassName}
      arrowColor={selectedTooltip.arrowColor}
    >
      {children}
    </SudoTooltip>
  );
};

export default MultiUseTooltip;
